import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import shortid from 'shortid'
import { DataInput } from './input-col-mobile'
import { InfoData, TaskData } from './info-col-mobile'
import * as timesheetHelper from '../../helpers/timesheet'

const filterTimesheetApproval = (data, myProjects, locations, searchApprovalDetail) => {
  return data.filter((element) => {
    const search = searchApprovalDetail.toLowerCase()
    const project = find(myProjects, { _id: element.project_id })
    const projectCode = project ? project.project_code.toLowerCase() : ''
    const projectName = project ? project.name.toLowerCase() : ''
    const approvers = project ? project.approvers : []
    const approver = find(approvers, { _id: element.approver_id })
    const approverName = approver ?
      `${approver.emp_code.toLowerCase()} - ${approver.first_name.toLowerCase()} ${approver.last_name.toLowerCase()} (${approver.nick_name.toLowerCase()})` : ''
    if (approverName.includes(search)
    || projectCode.includes(search)
    || projectName.includes(search)) return true
    const result = find(get(element, 'tasks', []), (task) => {
      const location = find(locations, { value: task.location_id })
      const locationName = location ? location.label.toLowerCase() : ''
      const taskName = task.task_name.toLowerCase()
      return locationName.includes(search) || taskName.includes(search)
    })
    return result
  })
}

export const DataRowMobile = (props) => {
  const projects = get(props, 'timesheetRequest.projects', [])
  const holidaysApproval = timesheetHelper.changeFormatDate(get(props, 'timesheetRequest.holidays', []))
  const compensateRequests = get(props, 'timesheetRequest.compensateRequests')
  const leaveRequests = get(props, 'timesheetRequest.leavesRequests')
  const { locations, searchApprovalDetail } = props
  let timesheetRequest = get(props, 'timesheetRequest.timesheetRequest.timesheet_snapshot.projects', [])
  timesheetRequest = filterTimesheetApproval(
    timesheetRequest, projects, locations, searchApprovalDetail)

  return (
    <Wrapper>
      { timesheetRequest.map((project) => {
        return (
          <InfoRow key={ shortid() }>
            <ContainerInfo>
              <InfoData
                project={ project }
                projects={ props.projects }
                { ...props }
              />
            </ContainerInfo>
            { project.tasks.map((task, taskID) => {
              return (
                <SumContainer key={ shortid() }>
                  <FirstCol />
                  <TaskContainer>
                    <Container>
                      <TaskData
                        task={ task }
                        taskID={ taskID }
                        projectID={ project.key }
                        showAdd={ taskID === project.tasks.length - 1 }
                        { ...props }
                      />
                    </Container>
                    <Container>
                      <DataInput
                        task={ task }
                        taskID={ taskID }
                        projectID={ project.key }
                        project={ project }
                        { ...props }
                        leaveRequests={ leaveRequests }
                        compensateRequests={ compensateRequests }
                        holidaysApproval={ holidaysApproval }
                      />
                      <LastCol />
                    </Container>
                  </TaskContainer>
                </SumContainer>
              )
            })
            }
          </InfoRow>
        )
      })
      }
    </Wrapper>
  )
}

DataRowMobile.propTypes = {
  projects: PropTypes.array,
  locations: PropTypes.array,
  searchApprovalDetail: PropTypes.string,
}
DataRowMobile.defaultProps = {
  projects: [],
  locations: [],
  searchApprovalDetail: '',
}

const Wrapper = styled.div`
  @media (max-width: 1199.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
  @media (max-width: 575.98px) {
    background-color: #FFFFFF;
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
  }
  @media (max-width: 767.98px) {
    background-color: #FFFFFF;
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const Container = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
`
const ContainerInfo = styled.div`
  height: 40px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const SumContainer = styled.div`
  @media (min-width: 1200px) {
    display: none;
  }
  width: 100%;
  height: 68px;
  flex: 1;
  display: flex;
  flex-direction: row;
  background-color: #F9F9F9;
`
const FirstCol = styled.div`
  width: 5%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  border-right: 1px solid #D44B49;
  margin-right: 2%;
`
const LastCol = styled.div`
  width: 10%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
`
const TaskContainer = styled.div`
  @media (min-width: 1200px) {
    display: none;
  }
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #F9F9F9;
`
const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/data-row-mobile.js